import { defineComponent as _defineComponent } from 'vue'
import { ref, toRef } from 'vue';
import type { TComplianceSummary } from '@/_core/entities/report/models/types';
import SearchInput from '@/_core/shared/ui/SearchInput/SearchInput.vue';
import { useComplianceFilter } from './useComplianceFilter';
import { useClickOutside } from './useClickOutside';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComplianceFilterDropdown',
  props: {
    summary: null,
    selectedRequirementId: null,
    selectedItemId: null
  },
  emits: ["select", "clear"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select', payload: { requirementId?: string; itemId?: string }): void;
  (e: 'clear'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  summary?: TComplianceSummary;
  selectedRequirementId?: string;
  selectedItemId?: string;
};





const isOpen = ref(false);
const rootRef = ref<HTMLElement | null>(null);

const { search, filteredGroups, selectedCount } = useComplianceFilter({
  summary: toRef(props, 'summary'),
  selectedRequirementId: toRef(props, 'selectedRequirementId'),
  selectedItemId: toRef(props, 'selectedItemId'),
  onClear: () => emit('clear'),
});

useClickOutside(rootRef, () => {
  isOpen.value = false;
});

function selectItem(itemId: string) {
  emit('select', { itemId });
}

function clearAll() {
  emit('clear');
  search.value = '';
}

return { __sfc: true,props, emit, isOpen, rootRef, search, filteredGroups, selectedCount, selectItem, clearAll, SearchInput }
}

})